import { Config } from '@chegg-wt/core/config'
import { migrationStatusToConstant } from '../utils/user'

export const getMigrateStatus = (migrationId: number) =>
  fetch(`${Config.migrateUrl}/${migrationId}`)
    .then((res) => res.json())
    .then(migrationStatusToConstant)

export const getMigrateStatusWithoutID = (jwt: string) => {
  if (!Config.migrateUrl) {
    return null
  }
  return fetch(`${Config.migrateUrl}`, {
    method: 'GET',
    headers: new Headers({
      Authorization: jwt,
    }),
  })
    .then((res) => res.json())
    .then((res: { status: boolean | string }) => {
      return res.status === true || res.status === 'completed'
    })
    .catch(() => null)
}
